module.exports = __webpack_public_path__ + "img/panhediaosu.5a69c2e6.png";